import { Component, OnInit, signal } from "@angular/core";
import { InputBlockComponent } from "../../input-block/input-block/input-block.component";
import { SmartCheckBoxBlock } from "../../types/block";

@Component({
  selector: "ail-smart-check-box-block",
  template: "",
})
export class SmartCheckBoxBlockComponent extends InputBlockComponent<SmartCheckBoxBlock>
  implements OnInit {
  readonly showCheckboxAnswers = signal(false);

  viewCheckBoxAnswers() {
    this.showCheckboxAnswers.set(true);
    this.inputFormControl().disable();
  }

  onSelectionChanged($event: Event, blockID, position) {
    this._sessionStore.updateSmartBoxQuestData($event.target['checked'], blockID, position);
  }
}
